module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../../node_modules/happypack/loader.js?id=jsx!./ShareGiftListView.js"));
	}, "ShareGiftListView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=ShareGiftListView!./src/pages/Shop/Member/Personal/GiftWarehouse/ShareGiftList/ShareGiftListView.js
// module id = 1511
// module chunks = 418